var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSunMoon = function SvgSunMoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.834 8A5.834 5.834 0 0 0 8 2.167l-.134.002a7.006 7.006 0 0 1 .004 11.66q.064.004.13.005A5.834 5.834 0 0 0 13.834 8M2.167 8A5.835 5.835 0 0 0 6 13.48a5.839 5.839 0 0 0-.003-10.96A5.84 5.84 0 0 0 2.167 8M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0"
  })));
};
export default SvgSunMoon;